export const lazyInit = (initializer) => {
    let value;
    return async () => {
        if (value === undefined) {
            value = await initializer();
        }
        return value;
    };
};
//# sourceMappingURL=lazyInit.js.map